import { RootState } from 'redux/store'

export const isDropoffFilterAppliedSelector = (state: RootState) =>
  state.dropoffReducer.isDropoffFilterApplied

export const dropoffFilterDataSelector = (state: RootState) =>
  state.dropoffReducer.dropoffFilterData
